import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { HistoryManager, NotificationManager } from '@atlas/core';
import { Button } from '@atlas/ui';

const TransactionCancelButton = ({ publicPaymentId, transactionId }) => {
  const cancelHandler = useCallback(() => {
    NotificationManager.display({
      data: {
        closeLabel: 'back',
        confirmLabel: 'cancel',
        onConfirm: () => {
          HistoryManager.cancel(HistoryManager.actions.operation.transaction, {
            publicPaymentId,
            transactionId,
          })
            .then(() => {
              NotificationManager.notify({
                message: 'transaction_cancel_successful',
                status: 'success',
                type: 'notification',
              });
            })
            .catch(error => {
              NotificationManager.notify({
                message: `transaction_error_${error.code}`,
                status: 'error',
                type: 'notification',
              });
            });
        },
      },
      message: 'confirm_withdrawal_cancellation',
      title: 'withdrawal_cancellation',
      type: 'confirm',
    });
  }, [transactionId]);

  return (
    <Button
      className="btn full-width"
      label="cancel_transaction"
      onClick={cancelHandler}
      type="secondary"
    />
  );
};

TransactionCancelButton.propTypes = {
  transactionId: PropTypes.number.isRequired,
  updateTransactionsAfterCancel: PropTypes.func.isRequired,
};

export default TransactionCancelButton;
